import { Button, Divider } from 'antd';
import classNames from 'classnames';
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Hamburger, SearchHamburger } from './Icons';

export const Header = () => {
  const [search, setSearch] = useState('');
  const [isSearchOpen, toggleSearch] = useState(false);
  const [isMenuOpen, toggleMenu] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (isMenuOpen) {
      toggleMenu(false);
      toggleSearch(false);
    }
    if (document.body.classList.contains('prevent-scroll')) {
      document.body.classList.remove('prevent-scroll');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const useMediaQuery = (width: number) => {
    const [targetReached, setTargetReached] = useState(false);

    const updateTarget = useCallback((e) => {
      if (e.matches) {
        setTargetReached(true);
      } else {
        setTargetReached(false);
      }
    }, []);

    useEffect(() => {
      const media = window.matchMedia(`(max-width: ${width}px)`);
      media.addEventListener('change', updateTarget);
      // Check on mount (callback is not called until a change occurs)
      if (media.matches) {
        setTargetReached(true);
      }

      return () => media.removeEventListener('change', updateTarget);
    }, []);

    return targetReached;
  };

  const isBreakpoint = useMediaQuery(768);

  type ContainerProps = {
    classNames?: string;
    isAvazTv?: boolean;
    width?: string;
    height?: string;
  };
  const Search = ({ classNames = 'sWH' }: ContainerProps) => (
    <svg
      className={classNames}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
      ></path>
    </svg>
  );

  const Close = ({ classNames = 'sWH' }: ContainerProps) => (
    <svg
      className={classNames}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
    </svg>
  );
  return (
    <header className="header-copy">
      {/* NAVBAR */}
      <div className="navbar-header">
        ​{/* NAVBAR__LOGO/SEARCH */}
        <div className={`navbar-logo ${isMenuOpen ? 'isOpenMargin' : ''}`}>
          {/* NAVBAR__HAMBURGER */}
          <button
            // mr-[7.8] kada se vrati LOGIN button
            className={`hamburgerButton btn  btn-ghost1`}
            aria-label="button"
            onClick={() => {
              if (!isMenuOpen) {
                toggleMenu(true);
                if (isBreakpoint) toggleSearch(true);

                //debouncedToggleMenu(!isMenuOpen);
                setTimeout(() => {
                  let test = document.getElementById('transition-e');
                  document.body.classList.add('prevent-scroll');
                  test?.classList.add('tr-effect-right');
                }, 1);
              } else {
                let test = document.getElementById('transition-e');
                if (document.body.classList.contains('prevent-scroll')) {
                  test?.classList.remove('tr-effect-right');
                  document.body.classList.remove('prevent-scroll');
                  setTimeout(() => {
                    toggleMenu(false);
                    if (isBreakpoint) toggleSearch(false);
                  }, 1);
                }
              }
            }}
          >
            {isMenuOpen ? (
              <Close />
            ) : (
              <div className="flex">
                <SearchHamburger classNames="hideSearchHamburger" /> <Hamburger classNames="hideHamburger" />
              </div>
            )}
          </button>
          {/* NAVBAR__LOGO */}
          <div className={classNames('navbar-logo-img', isSearchOpen && 'navbar-logo-im')}>
            <a href={'https://avaz.ba/'}>
              <img alt="Avaz Logo" src="/avaz.svg" style={{ minHeight: '50.6px', width: '190px' }} />
            </a>
          </div>
          <div className="left-part">
            <div style={{ marginRight: '29.5px' }}></div>
          </div>
          {/* NAVBAR__SEARCH */}
          <form
            action="/"
            className={classNames('navbar-search', !isSearchOpen && 'navbar-searc')}
            style={{
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          >
            <button
              type="submit"
              className={classNames('search-btnMini', !isSearchOpen && 'navbar-logo-im')}
              onClick={() => {
                toggleSearch(true);
              }}
            >
              <Search classNames="search-componentMini" />
            </button>
            <input
              name="q"
              value={search}
              type="text"
              minLength={3}
              onKeyPress={(e: any) => {
                if (e.target.value.length < 3) {
                  e.target.setCustomValidity('Molimo unesite više od 3 karaktera!');
                } else {
                  e.target.setCustomValidity('');
                }
              }}
              placeholder={'Pretražite...'}
              className="input-search"
              onChange={(e) => setSearch(e.target.value)}
              id="text-search"
            ></input>
          </form>
          <div className={'right-part'}>
            {!isBreakpoint && (
              <Button className={classNames('newObituaryBtn', isSearchOpen && 'navbar-logo-im')} href={'/objavi'}>
                <span className="big">OBJAVITE SMRTOVNICU</span>
                <span className="small">+</span>
              </Button>
            )}
            <button
              type="submit"
              className={classNames('search-btn', isSearchOpen && 'navbar-logo-im')}
              onClick={() => {
                toggleSearch(true);
              }}
            >
              <Search classNames="search-component" />
            </button>
            <button
              type="submit"
              className={classNames('close-btn', !isSearchOpen && 'close-btn-hide')}
              onClick={() => {
                toggleSearch(false);
              }}
            >
              <Close classNames="close-component"></Close>
            </button>
          </div>
        </div>
      </div>
      {/* MENU */}
      {isMenuOpen && (
        <div className="menuContainer">
          {/* MENU__OVERLAY */}
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
          <div
            onClick={() => {
              let test = document.getElementById('transition-e');
              if (document.body.classList.contains('prevent-scroll')) {
                test?.classList.remove('tr-effect-right');
                document.body.classList.remove('prevent-scroll');
                setTimeout(() => {
                  toggleMenu(false);
                }, 300);
              }
            }}
            className="menuGrowClick"
          />
          {/* MENU__LIST */}
          <div className="menuList" id="transition-e">
            <div className="menuListItem">
              <ul key={`menu-group`} className="listBetween">
                <div key={'SVE'}>
                  <li key={`menu-SVE`} className="listItem">
                    <a href="/" className="linkItem ">
                      <div className="listItemText">{'Sve'}</div>
                    </a>
                  </li>
                </div>
                <div key={'UMRLI'}>
                  <li key={`menu-UMRLI`} className="listItem">
                    <a href="/?tip=umrli" className="linkItem ">
                      <div className="listItemText">{'Umrli'}</div>
                    </a>
                  </li>
                </div>
                <div key={'SJECANJA'}>
                  <li key={`menu-SJECANJA`} className="listItem">
                    <a href="/?tip=sjecanja" className="linkItem ">
                      <div className="listItemText">{'Sjećanja'}</div>
                    </a>
                  </li>
                </div>
                <div key={'SUĆUTI'}>
                  <li key={`menu-SUĆUTI`} className="listItem">
                    <a href="/?tip=sucuti" className="linkItem ">
                      <div className="listItemText">{'Sućuti'}</div>
                    </a>
                  </li>
                </div>
                <Divider className="dividerMargin" />
                <div key={'OBJAVITE'}>
                  <li key={`menu-OBJAVITE`} className="listItem">
                    <a href="/objavi" className="linkItem ">
                      <div className="listItemTextRed">{'Objavite smrtovnicu'}</div>
                    </a>
                  </li>
                </div>
              </ul>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};
